import { useRef, FC } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { RouteProps } from 'react-router'
import queryString from 'qs'

import { Submit } from '../form'
import AuthTextField from './AuthTextField'
import { FieldWrapper } from './styles'
import { AuthToken } from './shared'

interface NewPasswordFormProps {
  location: RouteProps['location']
}

const validationSchema = Yup.object({
  user: Yup.object({
    password: Yup.string()
      .required('This field is required')
      .min(8, 'Password should be at least 8+ characters'),
    password_confirmation: Yup.string()
      .required('This field is required')
      .oneOf(
        [Yup.ref('password')],
        'Password confirmation should match password'
      ),
  }),
})

const NewPasswordForm: FC<NewPasswordFormProps> = ({ location }) => {
  const formElement = useRef<HTMLFormElement>(null)
  const {
    reset_password_token: resetToken,
  } = queryString.parse(location.search, { ignoreQueryPrefix: true })

  const form = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(validationSchema),
    defaultValues: { user: { password: '', password_confirmation: '' } },
  })
  const {
    handleSubmit,
    formState: { isDirty },
  } = form

  return (
    <FormProvider {...form}>
      <form
        className="qa-change-password"
        action="/users/password"
        method="post"
        ref={formElement}
        onSubmit={handleSubmit(() => formElement.current.submit())}
      >
        <AuthToken />
        <input type="hidden" name="_method" value="put" />
        <input
          type="hidden"
          value={resetToken as string}
          name="user[reset_password_token]"
        />

        <FieldWrapper>
          <AuthTextField
            label="New password"
            name="user[password]"
            type="password"
            noMargin
          />
        </FieldWrapper>

        <FieldWrapper margin="medium">
          <AuthTextField
            label="Confirm new password"
            name="user[password_confirmation]"
            type="password"
            noMargin
          />
        </FieldWrapper>

        <FieldWrapper>
          <Submit name="commit" disabled={!isDirty} fullwidth uppercase={false}>
            Change password
          </Submit>
        </FieldWrapper>
      </form>
    </FormProvider>
  )
}

export default NewPasswordForm
